import script from "./OrderSucess.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderSucess.vue?vue&type=script&setup=true&lang=ts"

import "./OrderSucess.vue?vue&type=style&index=0&id=7f9af818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f9af818"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QSeparator});
